import { API } from './apiWrapper';

import { useMutation } from './useMutation';

export const submitAIForm = async (formData: any) => {
  const data = await API.post('AiFormRequest', '/save?key=submit', {
    body: formData,
  });
  return data;
};

export const useSubmitAIForm = () => {
  return useMutation({ mutate: submitAIForm });
};
